import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

// HSA/FSA eligibility for a product (variant) or product family. Resolved from
// Shopify variant metafields; surfaced on the `HsaOrderContext` line items the
// customer-portal questionnaire renders.
//
//   - NOT_ELIGIBLE       — can't be paid for with HSA funds.
//   - ELIGIBLE           — payable with HSA card directly, no LMN required.
//   - ELIGIBLE_WITH_LMN  — payable only with a Letter of Medical Necessity
//                          (the path that runs the questionnaire flow).

export enum HsaEligibility {
  NOT_ELIGIBLE = "not_eligible",
  ELIGIBLE = "eligible",
  ELIGIBLE_WITH_LMN = "eligible_with_lmn",
}

export const hsaEligibility: z.ZodType<HsaEligibility> =
  createEnum(HsaEligibility);
